import { Flex, Text, FileUpload, type FileObjectType } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ArenaLockAction } from "../constants";
import * as styles from "./styles_vanilla.css";

type FileUploadSectionProps = {
  selectedAction: ArenaLockAction;
  selectedFiles: FileObjectType[];
  isLoading: boolean;
  isComplete: boolean;
  onFileSelected: (files: FileObjectType[]) => void;
};

export const FileUploadSection = ({
  selectedAction,
  selectedFiles,
  isLoading,
  isComplete,
  onFileSelected,
}: FileUploadSectionProps) => {
  return (
    <>
      <Text variant="secondary-md" className={styles.uploadInstructions}>
        Select a TSV configuration file to {selectedAction} the arena. The file should contain
        group configurations with the appropriate &quot;fund administered&quot; settings. The
        file will be uploaded when you click the{" "}
        {selectedAction === ArenaLockAction.LOCK ? "Lock Arena" : "Unlock Arena"} button.
      </Text>

      <div className={styles.uploadSection}>
        <Text variant="strong-md" className={styles.uploadSectionTitle}>
          Select TSV Configuration File
        </Text>
        <FileUpload
          onFileSelected={onFileSelected}
          acceptedFileTypes={[".tsv"]}
          isFullWidth
          isDisabled={isLoading || isComplete}
        />
        {selectedFiles.length > 0 && (
          <Flex alignItems="center" gap={Sizes.XS} className={styles.fileSelectedInfo}>
            <Icon type="file" color={Colors.Success600} size="small" />
            <Text variant="secondary-sm" className={styles.fileSelectedText}>
              {selectedFiles[0].file?.name} selected
            </Text>
          </Flex>
        )}
      </div>
    </>
  );
};
